import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { change as changeFieldValue, Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import MessageBox from "../../../../common/MessageBox";
import { SelectInput, TextInput } from "../../../../common/form";

class PersonalDataPreviewForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            configMessage: null,
            locale: null,
        };
    }

    componentDidMount() {
        const { configMessage } = this.props;
        const userLocale = localStorage.getItem("languageCode") || "en-CA";

        this.setState({ configMessage: configMessage, locale: userLocale });
    }

    render() {
        const { configMessage, locale } = this.state;
        const { selectedFieldsData } = this.props;

        const personalInfoObjProps = [
            "firstName",
            "lastName",
            "phoneNumber",
            "birthdate",
            "memberGenderType",
            "languageCode",
        ];

        const postalInfoObjProps = ["address", "city", "country", "province", "postalCode"];

        let hasPersonalInfoKey = false;
        let hasPostalInfoKey = false;

        personalInfoObjProps.forEach((elem) => {
            if (selectedFieldsData.hasOwnProperty(elem) && selectedFieldsData[elem]) {
                hasPersonalInfoKey = true;
                return hasPersonalInfoKey;
            }
        });

        postalInfoObjProps.forEach((elem) => {
            if (selectedFieldsData.hasOwnProperty(elem) && selectedFieldsData[elem]) {
                hasPostalInfoKey = true;
                return hasPostalInfoKey;
            }
        });

        return (
            <div>
                {configMessage && selectedFieldsData && (
                    <div>
                        <h3>
                            <FormattedMessage id="personalData.form.title" />
                        </h3>
                        {Object.keys(configMessage).length > 0 && (
                            <MessageBox className="alert-info bg-transparent">
                                {configMessage.localizations
                                    ? configMessage["localizations"][locale]["configMessage"]
                                    : ""}
                            </MessageBox>
                        )}
                        <div className="member-info-section">
                            <Field
                                id="previewMemberIdentifier"
                                name="previewMemberIdentifier"
                                component={TextInput}
                                label={<FormattedMessage id="personalData.form.memberIdentifier" />}
                                disabled={true}
                            />
                            <Field
                                id="previewEmail"
                                name="previewEmail"
                                component={TextInput}
                                label={<FormattedMessage id="personalData.form.email" />}
                                disabled={true}
                            />
                            <Field
                                id="previewConfirmEmail"
                                name="previewConfirmEmail"
                                className="field-gap"
                                component={TextInput}
                                label={<FormattedMessage id="personalData.form.confirmEmail" />}
                                disabled={true}
                            />
                        </div>

                        <h5>
                            <FormattedMessage id="personalData.form.verifyInformation" />
                        </h5>
                        <MessageBox className="alert-info bg-transparent">
                            <FormattedMessage id="personalData.form.informationMessage" />
                        </MessageBox>

                        <div className="personal-data-form-flex">
                            {hasPersonalInfoKey && (
                                <div className="member-info-section">
                                    {hasPersonalInfoKey && (
                                        <h5>
                                            <FormattedMessage id="personalData.form.personalInfoTitle" />
                                        </h5>
                                    )}
                                    {selectedFieldsData.firstName && (
                                        <Field
                                            id="previewFirstName"
                                            name="previewFirstName"
                                            component={TextInput}
                                            label={<FormattedMessage id="personalData.form.firstName" />}
                                            disabled={true}
                                        />
                                    )}
                                    {selectedFieldsData.lastName && (
                                        <Field
                                            id="previewLastName"
                                            name="previewLastName"
                                            component={TextInput}
                                            label={<FormattedMessage id="personalData.form.lastName" />}
                                            disabled={true}
                                        />
                                    )}
                                    {selectedFieldsData.phoneNumber && (
                                        <Field
                                            id="previewPhoneNumber"
                                            name="previewPhoneNumber"
                                            component={TextInput}
                                            label={<FormattedMessage id="personalData.form.phoneNumber" />}
                                            disabled={true}
                                        />
                                    )}
                                    {selectedFieldsData.emailAddress && (
                                        <Field
                                            id="previewEmailAddress"
                                            name="previewEmailAddress"
                                            component={TextInput}
                                            label={<FormattedMessage id="personalData.form.email" />}
                                            disabled={true}
                                        />
                                    )}
                                    {selectedFieldsData.birthdate && (
                                        <Field
                                            id="previewBirthDate"
                                            name="previewBirthDate"
                                            component={TextInput}
                                            label={<FormattedMessage id="personalData.form.birthDate" />}
                                            disabled={true}
                                        />
                                    )}
                                    {selectedFieldsData.memberGenderType && (
                                        <Field
                                            id="previewMemberGenderType"
                                            name="previewMemberGenderType"
                                            component={SelectInput}
                                            label={<FormattedMessage id="personalData.form.gender" />}
                                            options={[]}
                                            disabled={true}
                                        />
                                    )}
                                    {selectedFieldsData.languageCode && (
                                        <Field
                                            id="previewLanguageCode"
                                            name="previewLanguageCode"
                                            component={SelectInput}
                                            label={<FormattedMessage id="personalData.form.language" />}
                                            options={[]}
                                            disabled={true}
                                        />
                                    )}
                                </div>
                            )}
                            <div className="member-info-section">
                                {hasPostalInfoKey && (
                                    <h5>
                                        <FormattedMessage id="personalData.form.postalInfoTitle" />
                                    </h5>
                                )}
                                {selectedFieldsData.address && (
                                    <Field
                                        id="previewAddress"
                                        name="previewAddress"
                                        component={TextInput}
                                        label={<FormattedMessage id="personalData.form.address" />}
                                        disabled={true}
                                    />
                                )}
                                {selectedFieldsData.city && (
                                    <Field
                                        id="previewCity"
                                        name="previewCity"
                                        component={TextInput}
                                        label={<FormattedMessage id="personalData.form.city" />}
                                        disabled={true}
                                    />
                                )}
                                {selectedFieldsData.countryCode && (
                                    <Field
                                        id="previewCountry"
                                        name="previewCountry"
                                        component={SelectInput}
                                        label={<FormattedMessage id="personalData.form.country" />}
                                        disabled={true}
                                        options={[]}
                                    />
                                )}
                                {selectedFieldsData.provinceCode && (
                                    <Field
                                        id="previewProvince"
                                        name="previewProvince"
                                        component={SelectInput}
                                        label={<FormattedMessage id="personalData.form.province" />}
                                        disabled={true}
                                        options={[]}
                                    />
                                )}
                                {selectedFieldsData.postalCode && (
                                    <Field
                                        id="previewPostalCode"
                                        name="previewPostalCode"
                                        component={TextInput}
                                        label={<FormattedMessage id="personalData.form.postalCode" />}
                                        disabled={true}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

PersonalDataPreviewForm.propTypes = {
  configMessage: PropTypes.string,
  selectedFieldsData: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

function mapStateToProps(state) {
    const configMessageObj = state.form.configMessage;

    return {
        selectedFieldsData: state.form.personalDataConfiguration.values,
        configMessage: configMessageObj ? configMessageObj.values : {},
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDataPreviewForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/personal-data-configuration/PersonalDataPreviewForm.js